import React, { useState } from 'react';
import './LoginOverlay.css';

interface LoginOverlayProps {
  onLogin: (nickname: string) => void;
}

export const LoginOverlay = ({ onLogin }: LoginOverlayProps) => {
  const [name, setName] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmedName = name.trim();
    if (trimmedName) {
      onLogin(trimmedName);
    }
  };

  return (
    <div className="login-overlay-backdrop">
      <form className="login-overlay-card" onSubmit={handleSubmit}>
        <h1>Welcome to DeskShare</h1>
        <p>Please enter your name to continue. This will be saved on this computer for future visits.</p>
        <div className="input-group">
          <label htmlFor="nickname">Your Name</label>
          <input
            id="nickname"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g., Jane Doe"
            required
            autoFocus
          />
        </div>
        <button type="submit" className="login-button">
          Start Sharing
        </button>
      </form>
    </div>
  );
};